import GdOrgList from "@/components/GdOrgList";
import HBIcon from "@/components/HBIcon";
import classNames from "classnames";
import { ORGS_CLASS_MAP } from "../shared";
import styles from "./index.module.less";

export function OrgSelect({
  className = null,
  orgs,
  value,
  onChange,
  orgClass,
}) {
  return (
    <>
      <div className={classNames(styles.group, className)}>
        <div className={styles.title}>共享给：</div>
        <div className={styles.list}>
          <GdOrgList
            className={styles.orgs}
            dataSource={orgs}
            value={value}
            onChange={onChange}
          />
        </div>
      </div>

      <div
        className={classNames([
          styles.self,
          value === "" ? styles.active : null,
        ])}
        onClick={() => onChange("")}
      >
        <div className={styles.text}>
          {orgClass === ORGS_CLASS_MAP.PERSONAL
            ? "不共享, 仅自己使用"
            : "创建团队/企业并共享"}
        </div>
        <div className={styles.action}>
          <div className={styles.unchecked}></div>
          <HBIcon className={styles.checked} type="ic_check_circle" />
        </div>
      </div>
    </>
  );
}
